import React, { Fragment } from 'react'
import { FieldArray } from 'formik'

import { getNewLicense } from '../../enhancers/definitions/info'
import { FormattedMessage } from '@dragonraider5/react-intl'
import { Link } from 'react-router-dom'
import { showFieldError, renderValidation } from '../../../../../utils/validations'
import { getExceptionMessage } from '../../../../../utils/exceptions'
import Button from '../../../../../components/Button'
import Fieldset from '../../../../../components/FormFields/Fieldset'
import FormInfo from '../../../../../components/FormFields/FormInfo'
import { SectionSubTitle } from '../../../../../components/Section'
import FieldList, { FieldListHeader, FieldListItem, FieldListField, RemoveButton, AddButton } from '../../../../../components/FormFields/FieldList'
import FormActions from '../../../../../components/FormFields/FormAction/FormActions'
import FormError from '../../../../../components/FormFields/FormError'
import Input from '../../../../../components/FormFields/Input'

import { ReactComponent as AddIcon } from '../../../../../components/Icons/add-document-icon.svg'

import { getApplyToStepPath } from '../../../../MainRoutes/utils'
import { stepStatuses } from '../../../constants'
import { StatusSteps } from '../../StatusSteps'

function InfoForm({
  values,
  status = {},
  errors,
  touched,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit,
  application
}) {
  return (
    <form onSubmit={handleSubmit}>
      <Fieldset>
        <SectionSubTitle as='legend'>Licencias y permisos</SectionSubTitle>
        <FormInfo>Si el proyecto requiere de alguna licencia o permiso como licencias de actividad, licencias de obras, permisos de impacto medioambiental, etc. Añade con cuáles cumples con la normativa.</FormInfo>
        <FieldList>
          <FieldListHeader>
            <span>Licencias y permisos</span>
          </FieldListHeader>
          <FieldArray
            name='licenses'
            render={helpers => (
              <Fragment>
                {values.licenses.map((inf, index) => (
                  <FieldListItem key={inf.id || index}>
                    <FieldListField
                      error={showFieldError(`licenses[${index}].license`, { errors, touched })}
                      help={renderValidation(`licenses[${index}].license`, { errors, touched })}
                    >
                      <Input
                        name={`licenses[${index}].license`}
                        placeholder='Licencia y permiso'
                        value={inf.license}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={showFieldError(`licenses[${index}].license`, { errors, touched })}
                        full
                      />
                    </FieldListField>
                    <RemoveButton title='Eliminar' onClick={() => helpers.remove(index)} />
                  </FieldListItem>
                ))}
                <AddButton
                  onClick={() => helpers.push(getNewLicense())}
                >
                  Añadir <AddIcon />
                </AddButton>
              </Fragment>
            )}
          />
        </FieldList>
      </Fieldset>
      {status.error && (
        <FormError>
          <FormattedMessage {...getExceptionMessage(status.error)} />
        </FormError>
      )}
      <FormActions>
        <Button type='submit' disabled={isSubmitting}>Continuar</Button>
        <Link to={getApplyToStepPath(stepStatuses.PEOPLE, application)}>Volver</Link>
      </FormActions>
      <StatusSteps />
    </form>
  )
}

export default InfoForm
